import type { FC } from 'react'
import { useState } from 'react'
import styled from 'styled-components'

import { Button } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import CreateDocumentRequest from '@/components/DocumentRequests/CreateDocumentRequest'
import DocumentRequestList from '@/components/DocumentRequests/DocumentRequestsList'
import type { RefereeDetails } from '@/components/DocumentRequests/utils/types'
import { useGetDocumentRequestsQuery } from '@/lib/apollo'
import type { SectionName } from '@/lib/apollo/query/get-document-requests'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  onClose: () => void
  sectionName: SectionName
  subjectName: string
  isCorporateTenantSubject?: boolean
  refereeDetails?: RefereeDetails
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`

type SidebarView = 'view-requests' | 'create-request'

const DocumentRequestsSidebar: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  onClose,
  sectionName,
  subjectName,
  isCorporateTenantSubject,
  refereeDetails,
}) => {
  const [currentView, setCurrentView] = useState<SidebarView>('view-requests')
  const {
    loading,
    error: documentRequestError,
    data: documentRequestData,
    refetch,
  } = useGetDocumentRequestsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      customerId: customerId,
      applicationId: applicationId,
      subjectId: subjectId,
      sectionNames: [sectionName],
    },
  })

  return (
    <SlideInSidebar
      onClose={onClose}
      header={
        <h1>
          {currentView === 'view-requests' ? (
            <>Requests for {sectionName} documents</>
          ) : (
            <>Request a new {sectionName} document</>
          )}
        </h1>
      }
      content={
        <Container>
          {currentView === 'view-requests' ? (
            <>
              <DocumentRequestList
                customerId={customerId}
                applicationId={applicationId}
                subjectId={subjectId}
                triggerRefetch={refetch}
                documentRequestData={documentRequestData}
                isLoadingDocumentRequests={loading}
                error={documentRequestError}
                subjectName={subjectName}
              />
              <div className="side-by-side-flex-end">
                <Button onClick={() => setCurrentView('create-request')}>
                  Request a document
                </Button>
              </div>
            </>
          ) : (
            <CreateDocumentRequest
              customerId={customerId}
              applicationId={applicationId}
              subjectId={subjectId}
              onBack={() => setCurrentView('view-requests')}
              onIdentityChaserSent={() => {
                refetch()
                setCurrentView('view-requests')
              }}
              subjectName={subjectName}
              sectionName={sectionName}
              documentRequestData={documentRequestData}
              isCorporateTenantSubject={isCorporateTenantSubject ?? false}
              refereeDetails={refereeDetails}
            />
          )}
        </Container>
      }
    />
  )
}

export default DocumentRequestsSidebar
